import { Expose } from 'class-transformer';
import { IsObject, IsOptional, IsString } from 'class-validator';
import CreatedInfo, { Created } from './created-info';
import UpdatedInfo, { Updated } from './updated-info';

export class Section implements Created, Updated {
  @IsString()
  readonly id: string;

  @IsString()
  readonly label: string;

  @IsString()
  @Expose({ name: 'condominium_id' })
  readonly condominiumId: string;

  @IsOptional()
  @IsObject()
  readonly created?: CreatedInfo;

  @IsOptional()
  @IsObject()
  readonly updated?: UpdatedInfo;

  constructor(init?: Section) {
    this.id = init?.id!;
    this.label = init?.label!;
    this.condominiumId = init?.condominiumId!;

    this.created = init?.created ? new CreatedInfo(init?.created!) : undefined;
    this.updated = init?.updated ? new UpdatedInfo(init?.updated!) : undefined;
  }
}

export default Section;
